export const actions = {
  CP_CONFLICTIVO_LOAD_REQUESTED: 'CP_CONFLICTIVO_LOAD_REQUESTED',
  CP_CONFLICTIVO_LOAD_SUCCEEDED: 'CP_CONFLICTIVO_LOAD_SUCCEEDED',
  CP_CONFLICTIVO_LOAD_FILED: 'CP_CONFLICTIVO_LOAD_FILED',

  CP_CONFLICTIVO_UPDATE_REQUESTED: 'CP_CONFLICTIVO_UPDATE_REQUESTED',
  CP_CONFLICTIVO_UPDATE_SUCCEEDED: 'CP_CONFLICTIVO_UPDATE_SUCCEEDED',
  CP_CONFLICTIVO_UPDATE_FILED: 'CP_CONFLICTIVO_UPDATE_FILED',

  CP_CONFLICTIVO_INSERT_REQUESTED: 'CP_CONFLICTIVO_INSERT_REQUESTED',
  CP_CONFLICTIVO_INSERT_SUCCEEDED: 'CP_CONFLICTIVO_INSERT_SUCCEEDED',
  CP_CONFLICTIVO_INSERT_FILED: 'CP_CONFLICTIVO_INSERT_FILED',
}

export const getCPsConflictivosAction = dispatch => {
  dispatch({
    type: actions.CP_CONFLICTIVO_LOAD_REQUESTED,
  })
}

export const onSubmitInsertCPConflictivoFormAction = (dispatch, formCPConflictivo) => {
  dispatch({
    type: actions.CP_CONFLICTIVO_INSERT_REQUESTED,
    payload: formCPConflictivo,
  })
}

export const onSubmitUpdateCPConflictivoFormAction = (dispatch, formCPConflictivo) => {
  dispatch({
    type: actions.CP_CONFLICTIVO_UPDATE_REQUESTED,
    payload: formCPConflictivo,
  })
}
